// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"472":"674a8e8c","519":"70bc6877","542":"28cf5536","651":"cb9257ca","728":"9fdfef12","802":"ce237168","847":"64bafb63"}[chunkId] + ".chunk.js";
};